<template>
  <div class="form-group col-12">
    <div class="row">
      <label
        :class="fbhidelabel ? '' : 'col-sm-' + labelCol"
        class="col-form-label"
        v-if="fbhidelabel !== 'true'"
      >{{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      <i style="color: red;" v-if="fbrequired == 'true'">*</i>
      <div class="col-form-input" :class="fbhidelabel ? 'col-sm-12' : 'col-sm-' + (12 - labelCol)">
        <select
          v-show="fbreadonly !== 'true'"
          :id="id"
          ref="select"
          class="form-control form-control-select2"
          :data-placeholder="placeholder || ' '"
          v-bind:value="value"
          :required="fbrequired == 'true' ? true: false"
          :multiple="multiple || false"
        >
          <!-- <option></option>
          <option v-for="option in fboptions" :value="option.Key" :key="option.Key" :disabled="option.Disabled === true">{{ displayField ? option[displayField] : option.Value }}</option>-->
          <option v-for="option in fboptions" :value="option.id" :key="option.id" :disabled="option.Disabled === true">{{ displayField ? option[displayField] : option.text }}</option>
        </select>
        <!-- <input v-if="fbreadonly" type="text" :placeholder="placeholder" class="form-control" :value="valueText" :readonly="fbreadonly == 'true' ? true : false"> -->
        <label
          v-if="isValid === false"
          id="basic-error"
          class="validation-invalid-label"
          for="basic"
        >{{ $t('ui.SYS00016') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import helper from "@/vueHelper";

export default {
  // [{Key: 'a', Value: 'a'}, {Key: 'b', Value: 'b'}]
  name: "SelectBox",
  props: [
    "id",
    "fbsupportmultiplelanguages",
    "fblabel",
    "placeholder",
    "value",
    "fboptions",
    "fbreadonly",
    "fbrequired",
    "inDialog",
    "fbhidelabel",
    "multiple",
    "labelwidth",
    "displayField",
    "ajaxurl",
    "ajaxparam",
  ],
  data() {
    return {
      val: [],
      isValid: true,
      inited: false,
      select2: null
    };
  },
  methods: {
    setFocus() {
      this.$refs.select.focus();
    },
    setValid(val) {
      this.isValid = val;

      if (!val) {
        $(this.$refs.select)
          .next(".select2-container")
          .addClass("invalid");
      } else {
        $(this.$refs.select)
          .next(".select2-container")
          .removeClass("invalid");
      }
    },
    isFieldValid() {
      return (
        !this.required || (this.required && this.val && this.val.length > 0)
      );
    },
    resetValue() {
      this.isValid = true;
      this.val = [];
      $(this.$refs.select)
        .val(this.val)
        .trigger("change");
    },

  },
  computed: {
    // valueText () {
    //   var v = null
    //   if (this.val && this.options) {
    //     $.each(this.options, $.proxy(function (i, o) {
    //       if (this.val === o.Key) {
    //         v = this.displayField ? o[this.displayField] : o.Value
    //         return false
    //       }
    //     }, this))
    //   }

    //   return v
    // },
    labelCol() {
      return this.labelwidth || 3;
    }
  },
  mounted() {
    //this.init()

    //this.select2 = $(this.$el).find("select");
    this.select2 = $(this.$refs.select);
    let vm = this;

    var ajaxOpt = {
      delay: 250,
      url: config.serverURI + this.ajaxurl,
      dataType: "json",
      type: "POST",
      processResults: function(data, param) {
        if (data.code == 200) {
          return {
            results: data.data.lookups
            // pagination: {
            //   more : true
            // }
          };
        } else {
          alert("status code: " + data.code + " Message " + data.message);
          return {
            results: null
          };
        }
      },
      data: function(params) {

        // ajaxparam
        var queryParameters = {
          SessionID: vm.$helper.getSessionID(),
          LocaleCode: vm.$helper.getLocaleCode(),
          Parameters:{ //vm.ajaxparam
            // id: vm.$route.params.id,
             q: params.term,
             ...vm.ajaxparam
          }
          ,
          ApiKey: config.apiKey,
          ApiSystemName: config.apiSystemName
        };
        return JSON.stringify(queryParameters);
      },
      headers: {
        "Content-type": "application/json; charset=utf-8"
      }
    };

    this.$nextTick(() => {
      setTimeout(function() {
        vm.select2
          .select2({
            ajax: ajaxOpt,
            allowClear: true,
          })
          .trigger("change")
          // emit event on change.
          .on("change", function() {
            console.log('changed');
            vm.$emit("input", this.value);
          }).on("select2:unselecting", function() {
            $(this).data("unselecting", true);
          }).on("select2:opening", function(e) {
            if ($(this).data("unselecting")) {
              $(this).removeData("unselecting");
              e.preventDefault();
            }
          })
          // .on("select2:unselect", ev => {
          //   console.log('select unselect')

          //     //vm.$emit("change", '00000000-0000-0000-0000-000000000000');
          //     vm.$emit("input", '00000000-0000-0000-0000-000000000000');
          //   //vm.$emit("change", vm.select2.val());
          // //   vm.$emit("select", ev["params"]["data"]);
          // });
      }, 250);
    })

  },
  updated() {
  },
  destroyed() {
    this.select2.off().select2("destroy");
  },
  watch: {
    // value: function (val) {
    //   this.val = val || []
    //   $(this.$refs.select).val(this.val).trigger('change')
    //   this.setValid(this.isFieldValid())
    // },
    // readonly: function (val) {
    //   if (!val) {
    //     this.initSelect2()
    //     $(this.$refs.select).next('.select2-container').show()
    //   } else {
    //     $(this.$refs.select).next('.select2-container').hide()
    //   }
    // }
  }
};
</script>
<style>
.select2-selection--single .select2-selection__arrow:after {
  margin-right: 10px;
}
.select2-selection__placeholder {
  font-size: 0.8rem;
}
.select2-selection__rendered {
  padding-left: 13px !important;
  padding-top: 2px;
}
.select2-selection.select2-selection--single {
  /* min-height: 35px; */
  min-height: 42px;
}
.select2-selection--single {
  padding: 5px 0;
  /* border-bottom: 0px solid !important; */
}
.select2-search--inline,
.select2-search__field {
  width: 100% !important;
}
.select2-container--default .select2-selection--single .select2-selection__clear {
  padding-right: 20px;
  font-size: 24px;
}
</style>
